import { render, staticRenderFns } from "./ViqSourceCards.vue?vue&type=template&id=0d58c394&scoped=true"
import script from "./ViqSourceCards.vue?vue&type=script&lang=js"
export * from "./ViqSourceCards.vue?vue&type=script&lang=js"
import style0 from "./ViqSourceCards.vue?vue&type=style&index=0&id=0d58c394&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58c394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d58c394')) {
      api.createRecord('0d58c394', component.options)
    } else {
      api.reload('0d58c394', component.options)
    }
    module.hot.accept("./ViqSourceCards.vue?vue&type=template&id=0d58c394&scoped=true", function () {
      api.rerender('0d58c394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqSourceCards.vue"
export default component.exports